// src/oura/components/newscan/itemSource.ts
//
// Where a business fact came from, as the Business step labels it: an outlet
// row's source column and a service chip's mark. A First AI check adds three
// origins (JOURNEY-SPEC v1.1 §2.5): the client's form, the pitch and the
// quote. One copy for the outlet list and the services field.

import { FileTextIcon, GlobeIcon, HistoryIcon, MessageSquareIcon, PencilIcon, type LucideIcon } from "lucide-react";
import type { ItemSource } from "@service/aeo/scanDraftTypes";

export const ITEM_SOURCE: Record<ItemSource, { label: string; icon: LucideIcon }> = {
    site: { label: "On the site", icon: GlobeIcon },
    staff: { label: "Added by you", icon: PencilIcon },
    form: { label: "From the client's form", icon: MessageSquareIcon },
    scan: { label: "From the pitch", icon: HistoryIcon },
    quote: { label: "From the quote", icon: FileTextIcon },
};

/** An unknown value reads as the site (the contract's rule for older readers). */
export function itemSource(source: string | null | undefined): { label: string; icon: LucideIcon } {
    return ITEM_SOURCE[(source ?? "site") as ItemSource] ?? ITEM_SOURCE.site;
}

/** The three First AI check origins: their labels are longer, so the column widens. */
export const isSigningSource = (source: string | null | undefined): boolean => source === "form" || source === "scan" || source === "quote";
